(function () {
  "use strict";

  angular.module("sempraWebapp").component("workingSchedules", {
    templateUrl:
      "app/workingSchedulesAndHolidays/workingSchedules/workingSchedules.html",
    controller: workingSchedules,
    bindings: {
      workingSchedulesData: "<",
      allDayCheckBoxData: "<",
      siteId: "<",
      refresh: "&"
    },
    controllerAs: "vm"
  });

  function workingSchedules(workingSchedulesActions, $filter) {
    var vm = this;

    vm.scheduleList = [];

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.workingSchedulesData) {
        vm.scheduleList = changes.workingSchedulesData.currentValue;
        if(changes.workingSchedulesData.currentValue.length !== 0) {
          vm.scheduleList.forEach(function(item) {
            item.dayString = $filter('codeToDayName')(item.day);
          });
        }
      } else if (changes.siteId) {
        vm.siteId = changes.siteId.currentValue;
      }
    };

    vm.updateSchedules = function () {
      var data = {
        days: vm.scheduleList,
        state24h: vm.allDayCheckBoxData
      }
      workingSchedulesActions
        .updateWorkingSchedules(vm.siteId, data)
        .then(function () {});
    };

  }
})();
